import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const LegalTermsVersionRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--legal-terms-version']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
